var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: _vm.rootClasses,
      attrs: {
        role: _vm.isSemanticHeading ? null : "heading",
        "aria-level": _vm.isSemanticHeading ? _vm.headingLevel : 2,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }